export default __webpack_public_path__ + "static/media/Day_PlannerMAin.2762daa9.png";